(function () {
  'use strict';

  angular
    .module('plantProtection.exports')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('plantProtection.exports', {
        abstract: true,
        url: '/exports',
        template: '<ui-view />'
      });
  }
}());
